function findRootContentNode (node) {
  let n = node
  let i = 0

  while (n) {
    if (i++ > 50) //max call stack check
      return null

    if (n.contentId)
      return n

    n = n.$parent
  }
  return null
}

export default {
  install (Vue) {
    Vue.mixin({
      props: {
        contentId: {
          type: String,
          default: null
        },
        editPrefix: {
          type: String,
          default: ''
        }
      },
      data () {
        return {
          notEditable: false
        }
      },
      computed: {
        isEditable () {
          if (this.notEditable || (this.$parent && this.$parent.isEditable === false)) {
            return false
          } else {
            let rootContentNode = findRootContentNode(this)
            return rootContentNode && rootContentNode.$parent === this.$root && this.$root.editMode
          }
        },
        inEditMode () {
          return this.$root.editMode
        }
      }
    })
  }
}
